import user from './user';
import pay from './pay';
import share from './share';
import family from './family';
import data from './data';
import doumi from './doumi';
import ios from './ios';
export default {
  user,
  pay,
  share,
  family,
  data,
  doumi,
  ios
};
